<template>
  <app-layout>
    <router-link
      :to="{name: 'dashboard'}"
      exact
      class="q-pa-md block link">
      <q-icon name="fa fa-tachometer-alt" class="q-mr-sm"/> Dashboard
    </router-link>
    <h1 class="text-h6 q-mx-md">Administration</h1>
    <navigation :account-id="accountId" />
  </app-layout>
</template>

<script>
import AppLayout from '@/layout/AppLayout.vue';
import Navigation from '../nav/Navigation.vue';

export default {
  components: {
    AppLayout,
    Navigation,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
};
</script>
